import axios from "axios";

export const callWasteCodeMatrixService = async (qs) => {
  return await axios.get(`/api/v1/hwts/waste-codes/matrix?${qs}`);
};
